export default "__VITE_ASSET__631d150a__"